import SearchResults from './SearchResults';
import SearchResultsContainer from './SearchResultsContainer';

export default SearchResultsContainer;
export { SearchResults };
